import './SearchLayout.css';

import { Col, Collapse, Icon, Layout, Row, Modal, Button } from 'antd';
import * as React from 'react';
import config from 'src/config';

import { MultiList, ReactiveBase, ReactiveComponent } from '@appbaseio/reactivesearch';

import { SearchHeader } from '../components/search/SearchHeader';
import { SearchResults } from '../components/search/SearchResults';
import HomePage from "../components/HomePage";
import CollectionTreeWrapper from '../components/search/CollectionTreeWrapper';
import TermConditions from '../components/TermConditions';
import * as jwt from 'jsonwebtoken';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
const moment = require('moment');
const printJS = require('print-js');
const qs = require('query-string');
const xPortalTokenCookie = 'x-portal-token';

const { Content } = Layout;
const Panel = Collapse.Panel;
const { expiryDays } = config;

let restrictedCollectionIds: string[] = config.restrictedCollectionIds.replace(/\s/g, '').split(',');

class SearchLayout extends React.Component<any, any> {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  };
  constructor(props: any) {
    super(props);
    this.updateFilterState = this.updateFilterState.bind(this);

    this.state = {
      restrictedCollectionIds,
      collectionFilterValues: null,
      homePageVisible: true,
      termConditionVisible: true,
    };
  }

  componentWillMount(): void {
    const token = this.retrieveToken();
    const { cookies } = this.props;
    if (token) {
      const tokenPayload: any = jwt.decode(token);
      try {
        jwt.verify(token, config.publicKey);
        this.setRestrictionCollections(tokenPayload);
        this.props.updateShowMessage('valid');
        sessionStorage.setItem(xPortalTokenCookie, token);
        cookies.set(xPortalTokenCookie, token, {path:'/', expires: moment().utc().add(10, 'year').toDate()});
      } catch (ex) {
        if (ex.name === 'TokenExpiredError') {
          const iatDate = moment.unix(tokenPayload.iat).utc();
          const expiryDate = iatDate.add(expiryDays, 'days').utc();
          if (moment.utc().diff(expiryDate, 'seconds') > 0) {
            // token expire more than {expiryDays} days, display re-login message.
            this.props.updateShowMessage( 'relogin' );
            sessionStorage.removeItem(xPortalTokenCookie);
          } else {
            this.setRestrictionCollections(tokenPayload);
            this.props.updateShowMessage('valid');
            sessionStorage.setItem(xPortalTokenCookie, token);
            cookies.set(xPortalTokenCookie, token, {path:'/', expires: moment().utc().add(10, 'year').toDate()});
          }
        } else {
          // display error message.
          this.props.updateShowMessage( 'tokenError' );
          sessionStorage.removeItem(xPortalTokenCookie);
        }
      }
    } else {
      sessionStorage.removeItem(xPortalTokenCookie);
    }

    const displayTermConditions = sessionStorage.getItem('displayTermConditions');

    if (displayTermConditions && displayTermConditions == 'false') {
      this.setState({ termConditionVisible: false });
    }
  }

  setRestrictionCollections = (tokenPayload: any) => {
    if (tokenPayload && tokenPayload['scope']) {
      const scope = tokenPayload['scope'] + '';
      if (scope.startsWith('staff') || scope.startsWith('state-rec')) {
        this.setState({ restrictedCollectionIds: [] });
      }
    }
  };

  retrieveToken = () => {
    const params = qs.parse(this.props.location.search);
    const { cookies }= this.props;
    if (params && params[xPortalTokenCookie]) {
      const token = params[xPortalTokenCookie] + "";
      return token.replace(/^"(.*)"$/, '$1');
    } else if (cookies.get(xPortalTokenCookie)) {
      return cookies.get(xPortalTokenCookie)
    } else {
      return null;
    }
  };

  showHideHomePage = (value: []) => {
    if (value && value.length) {
      this.setState({homePageVisible: false})
    }
  };

  hideTermCondition = () => {
    this.setState({termConditionVisible: false});
    sessionStorage.setItem("displayTermConditions", "false");
  };

  printTermCondition = () => {
    printJS({ printable: "termsNConditions", type: 'html', header: 'HLRV Terms And Conditions', documentTitle: 'HLRV Terms And Conditions'});
  };

  render() {
    return (
      <ReactiveBase
        app={config.search.INDEX_NAME}
        url={config.search.ELASTIC_SEARCH_HOST}
        headers={{"x-portal-token": sessionStorage.getItem("x-portal-token") ? sessionStorage.getItem("x-portal-token") + "" : ""}}
      >
        <Modal
          title="HLRV Terms And Conditions"
          visible={this.state.termConditionVisible}
          width={'80vw'}
          bodyStyle={{ padding: 20 }}
          style={{ top: 75 }}
          onOk={this.hideTermCondition}
          okText="Accept"
          closable={false}
          footer={[
            <Button htmlType="button" key="accept" onClick={this.hideTermCondition}>Accept</Button>,
            <Button htmlType="button" key="print" onClick={this.printTermCondition}>Print</Button>
          ]}
        >
          <div style={{overflowY: "auto", height: "60vh", padding: '0 20px 0 0'}}>
            <TermConditions/>
          </div>
        </Modal>
        <Layout style={{ minHeight: '100vh' }}>
          <Content>
            <Row gutter={24}>
              <Row>
                <SearchHeader
                  useUrlParams={this.props.useUrlParams}
                  collectionFilterValues={this.state.collectionFilterValues}
                  restrictedCollectionIds={this.state.restrictedCollectionIds}
                  onShowHideHomePage={this.showHideHomePage}
                  setQuery={this.props.setQuery}
                />
              </Row>
              <Row gutter={24}>
                <Col sm={24} md={8} lg={6}>
                  <div className="rounded-box">
                    <h3>
                      <Icon type="search" /> Refine Search
                    </h3>
                    <Collapse
                      bordered={false}
                      defaultActiveKey={['0', '1', '2', '3']}
                    >
                      <Panel header="Collection" key="0">
                        <ReactiveComponent
                          componentId="collectionFilter"
                          filterLabel="Collection"
                          render={({ setQuery, value }) => (
                            <CollectionTreeWrapper
                              selectedCollectionIds={value}
                              updateFilterState={this.updateFilterState}
                              restrictedCollectionIds={this.state.restrictedCollectionIds}
                              setQuery={setQuery}
                            />
                          )}
                        />
                      </Panel>
                      <Panel header="District Office" key="1">
                        <MultiList
                          componentId="districtOfficeFilter"
                          dataField="districtOfficeName.lowercase"
                          URLParams={this.props.useUrlParams}
                          selectAllLabel="All"
                          showMissing={true}
                          showCheckbox={true}
                          showCount={false}
                          showFilter={true}
                          filterLabel='District Office'
                          size={100}
                          sortBy={'asc'}
                          renderItem={(label) => (
                            <div>
                              {label.toUpperCase()}
                            </div>
                          )}
                          react={{
                            and: [
                              'keywordSearch',
                              'attributeSearch',
                              'fromYearAttributeSearch',
                              'toYearAttributeSearch',
                              'parishNameFilter',
                              'countyNameFilter',
                              'collectionFilter',
                              'lotSearch'
                            ]
                          }}
                          onValueChange={this.showHideHomePage}
                        />
                      </Panel>
                      <Panel header="County Name" key="2">
                        <MultiList
                          componentId="countyNameFilter"
                          dataField="countyName.lowercase"
                          URLParams={this.props.useUrlParams}
                          selectAllLabel="All"
                          showMissing={true}
                          showCheckbox={true}
                          showCount={false}
                          showFilter={true}
                          filterLabel='County'
                          size={100}
                          sortBy={'asc'}
                          renderItem={(label) => (
                            <div>
                              {label.toUpperCase()}
                            </div>
                          )}
                          react={{
                            and: [
                              'keywordSearch',
                              'attributeSearch',
                              'fromYearAttributeSearch',
                              'toYearAttributeSearch',
                              'parishNameFilter',
                              'districtOfficeFilter',
                              'collectionFilter',
                              'lotSearch'
                            ]
                          }}
                          onValueChange={this.showHideHomePage}
                        />
                      </Panel>
                      <Panel header="Parish Name" key="3">
                        <MultiList
                          componentId="parishNameFilter"
                          dataField="parishName.lowercase"
                          URLParams={this.props.useUrlParams}
                          selectAllLabel="All"
                          showMissing={true}
                          showCheckbox={true}
                          showCount={false}
                          showFilter={true}
                          filterLabel='Parish'
                          size={100}
                          sortBy={'asc'}
                          renderItem={(label) => (
                            <div>
                              {label.toUpperCase()}
                            </div>
                          )}
                          react={{
                            and: [
                              'keywordSearch',
                              'attributeSearch',
                              'fromYearAttributeSearch',
                              'toYearAttributeSearch',
                              'countyNameFilter',
                              'districtOfficeFilter',
                              'collectionFilter',
                              'lotSearch'
                            ]
                          }}
                          onValueChange={this.showHideHomePage}
                        />
                      </Panel>
                    </Collapse>
                  </div>
                </Col>
                <Col sm={24} md={16} lg={18}>
                  {!this.state.homePageVisible && (
                    <SearchResults />
                  )}
                  {this.state.homePageVisible && (
                    <HomePage/>
                  )}
                </Col>
              </Row>
            </Row>
          </Content>
        </Layout>
      </ReactiveBase>
    );
  }

  updateFilterState(selectedCollectionIds: any) {
    this.setState({
      collectionFilterValues: selectedCollectionIds
    });
    this.showHideHomePage(selectedCollectionIds);
  }
}

export default withCookies(SearchLayout);



// WEBPACK FOOTER //
// ./src/layouts/SearchLayout.tsx